import { Entry } from '../App';
import { v4 as uuidv4 } from 'uuid';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export const sanitizeMarkdown = async (markdownText: string): Promise<string> => {
  const rawHtml = await marked.parse(markdownText);
  return DOMPurify.sanitize(rawHtml);
};

export const createEntry = async (
  qrText: string,
  markdownText: string
): Promise<Entry> => {
  const sanitizedHtml = await sanitizeMarkdown(markdownText);

  return {
    id: uuidv4(),
    qrText,
    markdownText,
    sanitizedHtml,
    isEditing: false,
    isNew: true,
    showPreviewWhileEditing: false,
  };
};
